import { forwardRef } from 'react';
import { WizardDrawer } from '@goodfynd/forms';
import type { DrawerRefMethods } from '@goodfynd/hooks';

import { CommunicationsPreferencesWizard } from './CommunicationsPreferencesWizard';
import type {
  CommunicationsPreferencesWizardDrawerProps,
  CommunicationsPreferencesWizardFields,
} from './types';

export const CommunicationsPreferencesWizardDrawer = forwardRef(
  function CommunicationsPreferencesWizardDrawer(
    { wizardProps, ...props }: CommunicationsPreferencesWizardDrawerProps,
    ref: React.ForwardedRef<DrawerRefMethods | null>
  ) {
    return (
      <div>
        <WizardDrawer<CommunicationsPreferencesWizardFields>
          ref={ref}
          targetContent="Communications"
          renderWizard={(props, ref) => (
            <CommunicationsPreferencesWizard
              {...props}
              {...wizardProps}
              ref={ref}
              title="Communications"
            />
          )}
          {...props}
        />
      </div>
    );
  }
);
